var _excluded = ["transformations", "quality", "pixelDensity"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _Set from "@babel/runtime-corejs3/core-js/set";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js/instance/some";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Array$isArray from "@babel/runtime-corejs3/core-js/array/is-array";
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import warn from "../warn.js";
var exclusiveTransforms = new _Set(['rotate', 'crop', 'smartCrop', 'fit']);
var includesAnyExclusiveTransforms = function includesAnyExclusiveTransforms(transformationParams) {
  var _context;
  return _someInstanceProperty(_context = _Object$keys(transformationParams)).call(_context, function (transform) {
    return exclusiveTransforms.has(transform);
  });
};
var createTransformationQuery = function createTransformationQuery() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    transformations = _ref.transformations,
    quality = _ref.quality,
    _ref$pixelDensity = _ref.pixelDensity,
    pixelDensity = _ref$pixelDensity === void 0 ? 1 : _ref$pixelDensity,
    transformationParams = _objectWithoutProperties(_ref, _excluded);
  var explicitOrdering = _Array$isArray(transformations);
  if (transformations && includesAnyExclusiveTransforms(transformationParams)) {
    warn('Included transformations prop with other transforms. These other transforms will be ignored.');
  }
  var normalizedTransformations = transformations;
  if (!normalizedTransformations) {
    // backwards compat
    normalizedTransformations = [transformationParams];
  } else if (!_Array$isArray(normalizedTransformations)) {
    normalizedTransformations = [normalizedTransformations];
  }
  var transformationStrings = _flatMapInstanceProperty(normalizedTransformations).call(normalizedTransformations, function (thisTransformation) {
    var _thisTransformation$w = thisTransformation.width,
      width = _thisTransformation$w === void 0 ? 'w' : _thisTransformation$w,
      _thisTransformation$h = thisTransformation.height,
      height = _thisTransformation$h === void 0 ? 'h' : _thisTransformation$h,
      rotate = thisTransformation.rotate,
      crop = thisTransformation.crop,
      smartCrop = thisTransformation.smartCrop,
      fit = thisTransformation.fit;
    var sizingCommand = smartCrop ? 'sc' : 'rs';
    var transformationCommands = [];
    var actualWidth;
    var actualHeight;
    if (width === 'w') {
      actualWidth = width;
    } else {
      actualWidth = Math.ceil(width * pixelDensity);
    }
    if (height === 'h') {
      actualHeight = height;
    } else {
      actualHeight = Math.ceil(height * pixelDensity);
    }
    if ("".concat(actualWidth, ".").concat(actualHeight) !== 'w.h') {
      if (fit && sizingCommand === 'rs') {
        transformationCommands.push("".concat(sizingCommand, "_").concat(actualWidth, ".").concat(actualHeight, ".fit"));
      } else {
        transformationCommands.push("".concat(sizingCommand, "_").concat(actualWidth, ".").concat(actualHeight));
      }
    }
    if (rotate) {
      transformationCommands.push("rt_".concat(rotate));
    }
    if (crop) {
      transformationCommands.push("cr_".concat(crop.join('.')));
    }
    return transformationCommands;
  });
  var transformationQuery = '';
  if (transformationStrings.length > 0) {
    transformationQuery += "~".concat(transformationStrings.join('-'));
  }
  var queryParams = [];
  if (quality) {
    queryParams.push("quality=".concat(quality));
  }
  if (explicitOrdering) {
    queryParams.push("ordering=explicit");
  }
  var queryString = queryParams.length > 0 ? "?".concat(queryParams.join('&')) : '';
  return [transformationQuery, queryString].join('');
};
export default createTransformationQuery;